import React from "react";

class ApMobileBottomPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  toggleExpandedMode() {
    const newState = !this.state.expanded;
    this.setState({ expanded: newState });
  }

  render() {
    const { expanded } = this.state;
    const { visible, expandable, annotations } = this.props;

    if (expanded === true && visible === false)
      this.setState({ expanded: false });

    const classNames =
      "ApMobileAnnotationPanel" +
      (visible ? "" : " ApMobileAnnotationPanel-Hidden");

    const expandBtnClass = `fas fa-caret-${
      expanded ? "down" : "up"
    } ApMobilePanelExpandBtn`;

    return (
      <div className={classNames} style={{ height: expanded ? "85%" : "45%" }}>
        <div id="Head">
          <i
            className="fas fa-times ApMobilePanelCloseBtn"
            onClick={() => this.props.onClose()}
          />
          <div className="Spacer-HB" />
          <p>{this.props.title}</p>
          {expandable ? (
            <i
              className={expandBtnClass}
              onClick={() => this.toggleExpandedMode()}
            />
          ) : null}
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default ApMobileBottomPanel;



// WEBPACK FOOTER //
// ./src/components/approval/mobile/ApMobileBottomPanel.js